/**
 *
 * ImageComponent
 *
 */
import React, { memo } from 'react';
import Avatar from 'assets/icons/Avatar.svg';
import { getImageUrl } from 'core/utils/constants';

// Generate unique ID once per page load
interface Props {
  url: string;
  className?: string;
  alternativeImage?: string | any;
  alt?: string;
  width?: number;
  height?: number;
}

export const ImageComponent = memo((props: Props) => {

  const handleError = (event: React.SyntheticEvent<HTMLImageElement, Event>) => {
    const target = event.target as HTMLImageElement;
    target.onerror = null;
    target.alt = props?.alt ? props?.alt : 'avatar';
    target.src = props?.alternativeImage ? props?.alternativeImage : Avatar;
    target.style.color = 'lightgrey';
    target.style.width = props?.width ? `${props?.width}%` : '50%';
    target.style.height = props?.height ? `${props?.height}px` : 'auto';
    target.style.marginRight = '3px'; // Fixed typo: margingRight -> marginRight
  };

  return (
    <>
      {!!props?.url ? (
        <img
          src={getImageUrl(props.url)}
          alt={props?.alt || 'image-component'}
          onError={handleError}
          className={`${props?.className ? props?.className : `!w-10 !h-10 rounded-full object-cover mx-0`}`}
        />
      ) : (
        <img
          src={props?.alternativeImage ? props?.alternativeImage : Avatar}
          className={`${props?.className ? props?.className : `!w-10 !h-10 rounded-full object-cover mx-0`}`}
          alt={props?.alt || 'avatar'}
        />
      )}
    </>
  );
});